
import { validationMixin } from "vuelidate";
import { SistemaMixin } from "@/modules/Application";
import TributacaoData, { TributacaoDataRequired } from "./TributacaoData";
import { Money } from "v-money";

export default {
  name: "app-tributacao-form",
  props: {
    url: {
      type: String,
    },
    tributacao: {
      type: Object,
      default: () => {},
    },
  },
  mixins: [validationMixin, SistemaMixin],
  data() {
    return {
      tabIndex: 0,
      form: {},
      configMoney: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "%",
        precision: 2,
        masked: false,
      },
      aliquota: [],
    };
  },
  components: {
    Money,
  },
  validations: {
    form: TributacaoDataRequired,
  },
  tributacao: {
    produto(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.form = newValue;
      }
    },
  },
  mounted() {
    this.getDataInit();
  },
  methods: {
    async getDataInit() {
      this.form = new TributacaoData({});
      this.aliquota = this.form.aliquota;
      if (this.tributacao.id) {
        this.form = this.tributacao;
      }
    },
    setActiveTab(event) {
      const tab = event.target.closest('[role="tablist"]');
      const links = tab.querySelectorAll(".nav-link");

      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }

      this.tabIndex = parseInt(event.target.getAttribute("data-tab"));

      event.target.classList.add("active");
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    async onSubmit() {
      const submitButton = this.$refs["submit_nova_tributacao"];
      try {
        this.$v.form.$touch();

        if (this.$v.form.$anyError) {
          return;
        }

        submitButton.classList.add("spinner", "spinner-light", "spinner-right");
        submitButton.setAttribute("disabled", "");

        await this.$http.post(this.url, this.form);

        this.$router.push({ name: "tributacoesLista" });
      } catch (error) {
        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
        submitButton.removeAttribute("disabled", "");
      }
    },
  },
};
